module.exports = __webpack_public_path__ + "img/bot_qf1.61c01c7e.png";